import { ChessTermType, TermAction, } from "@chesshotel/types";
import { Chess, PAWN, QUEEN, ROOK, KING, } from "@chesshotel/chess";
import { uci2move } from "./util.js";
function isStartingPosition(piece, square) {
    const startingPositions = {
        w: {
            p: ["a2", "b2", "c2", "d2", "e2", "f2", "g2", "h2"],
            n: ["b1", "g1"],
            b: ["c1", "f1"],
            r: ["a1", "h1"],
            q: ["d1"],
            k: ["e1"],
        },
        b: {
            p: ["a7", "b7", "c7", "d7", "e7", "f7", "g7", "h7"],
            n: ["b8", "g8"],
            b: ["c8", "f8"],
            r: ["a8", "h8"],
            q: ["d8"],
            k: ["e8"],
        },
    };
    return startingPositions[piece.color][piece.type].includes(square);
}
function detectMoveDevelopedPiece(fen, move, moveNr) {
    const chess = new Chess(fen);
    const { from, to } = uci2move(move);
    const piece = chess.get(from);
    if (!piece || piece.type === PAWN) {
        return null;
    }
    const startingPosition = isStartingPosition(piece, from);
    if (!startingPosition && moveNr <= 18) {
        const moveResult = chess.move({ from, to });
        return {
            term: ChessTermType.MOVE_DEVELOPED_PIECE,
            mainPiece: {
                type: piece.type,
                square: moveResult.to,
                color: piece.color,
            },
            move: moveResult,
            termAction: TermAction.PERFORM,
        };
    }
}
function checkHasMoved(move, moveIndex, allMoves) {
    for (let i = 0; i < moveIndex - 1; i++) {
        if (allMoves[i].from == move.from) {
            return true;
        }
    }
    return false;
}
function detectPieceDevelopment(fen, move, moveIndex, allMoves) {
    const chess = new Chess(fen);
    const color = chess.turn();
    const moveObj = uci2move(move);
    const piece = chess.get(moveObj.from);
    if (!piece || piece.type === PAWN || piece.type === KING) {
        return null;
    }
    let term = ChessTermType.DEVELOPMENT;
    if (piece.type == ROOK) {
        term = ChessTermType.ACTIVATE_ROOK;
    }
    if (piece.type == QUEEN) {
        term = ChessTermType.ACTIVATE_QUEEN;
    }
    const hasMoved = checkHasMoved(moveObj, moveIndex, allMoves);
    if (isStartingPosition(piece, moveObj.from) && !hasMoved) {
        const moveResult = chess.move(moveObj);
        if (moveResult) {
            const translationKeys = { piece: piece.type, color };
            const arrows = [
                {
                    from: moveResult.from,
                    to: moveResult.to,
                },
            ];
            return {
                term,
                mainPiece: {
                    type: piece.type,
                    square: moveResult.to,
                    color: piece.color,
                },
                move: moveResult,
                arrows,
                translationKeys,
            };
        }
    }
    return null;
}
function detectQueenEarly(fen, move, moveIndex) {
    const chess = new Chess(fen);
    const from = move.slice(0, 2);
    const to = move.slice(2, 4);
    const piece = chess.get(from);
    if (!piece || piece.type != QUEEN || moveIndex > 12) {
        return null;
    }
    if (isStartingPosition(piece, from)) {
        const moveResult = chess.move({ from, to });
        if (moveResult) {
            return {
                term: ChessTermType.DEVELOP_QUEEN_EARLY,
                termAction: TermAction.PERFORM,
                mainPiece: {
                    type: piece.type,
                    square: moveResult.to,
                    color: piece.color,
                },
                move: moveResult,
            };
        }
    }
    return null;
}
export function detectNegativeDevelop(position, lastPosition, allMoves) {
    const queenEarly = detectQueenEarly(lastPosition.fen, position.move, position.moveIndex);
    if (queenEarly)
        return queenEarly;
    const missDevelopPiece = detectMissedDevelopPiece(position, lastPosition, allMoves);
    if (missDevelopPiece)
        return missDevelopPiece;
    const moveDevelopedPiece = detectMoveDevelopedPiece(lastPosition.fen, position.move, position.moveIndex);
    if (moveDevelopedPiece)
        return moveDevelopedPiece;
}
export function detectMissedDevelopPiece(position, lastPosition, allMoves) {
    const userDevelop = detectPieceDevelopment(lastPosition.fen, position.move, position.moveIndex, allMoves);
    const bestDevelop = detectPieceDevelopment(lastPosition.fen, lastPosition.bestMove, position.moveIndex, allMoves);
    if (!userDevelop && bestDevelop) {
        return {
            ...bestDevelop,
            termAction: TermAction.MISS,
        };
    }
    if (userDevelop && bestDevelop) {
        if (userDevelop.term == bestDevelop.term) {
            return {
                ...bestDevelop,
                termAction: TermAction.BETTER_WAY,
            };
        }
        else {
            return {
                ...bestDevelop,
                termAction: TermAction.BETTER_WAY,
                term: ChessTermType.DEVELOPMENT,
            };
        }
    }
}
export function detectPerformDevelopPiece(position, lastPosition, allMoves) {
    const userDevelop = detectPieceDevelopment(lastPosition.fen, position.move, position.moveIndex, allMoves);
    if (userDevelop) {
        return {
            ...userDevelop,
            term: ChessTermType.DEVELOPMENT,
            termAction: TermAction.PERFORM,
        };
    }
}
//# sourceMappingURL=opening.js.map